"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDrillTargetsHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var drillTargets_1 = require("../../events/drillTargets");
var drillTargets_2 = require("../../store/drillTargets");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var widgetValidations_1 = require("../widgets/validation/widgetValidations");
var configSelectors_1 = require("../../store/config/configSelectors");
var availableDrillTargetsValidation_1 = require("./validation/availableDrillTargetsValidation");
var validateDrills_1 = require("../common/validateDrills");
var renderModeSelectors_1 = require("../../store/renderMode/renderModeSelectors");
var validateDrillToCustomUrlParams_1 = require("../common/validateDrillToCustomUrlParams");
function addDrillTargetsHandler(ctx, cmd) {
    var availableDrillTargets, correlationId, widgets, enableKPIDashboardDrillFromAttribute, insightWidget, drillTarget, ref, uri, identifier, isInEditMode;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                availableDrillTargets = cmd.payload.availableDrillTargets, correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _a.sent();
                return [4 /*yield*/, effects_1.select(configSelectors_1.selectEnableKPIDashboardDrillFromAttribute)];
            case 2:
                enableKPIDashboardDrillFromAttribute = _a.sent();
                insightWidget = widgetValidations_1.validateExistingInsightWidget(widgets, cmd, ctx);
                drillTarget = availableDrillTargetsValidation_1.availableDrillTargetsValidation(availableDrillTargets, enableKPIDashboardDrillFromAttribute, ctx, cmd);
                ref = insightWidget.ref, uri = insightWidget.uri, identifier = insightWidget.identifier;
                return [4 /*yield*/, effects_1.put(drillTargets_2.drillTargetsActions.addDrillTargets({
                        identifier: identifier,
                        uri: uri,
                        ref: ref,
                        availableDrillTargets: drillTarget,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(renderModeSelectors_1.selectIsInEditMode)];
            case 4:
                isInEditMode = _a.sent();
                if (!isInEditMode) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(validateDrills_1.validateDrills, ctx, cmd, [insightWidget])];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(validateDrillToCustomUrlParams_1.validateDrillToCustomUrlParams, [insightWidget])];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/, drillTargets_1.drillTargetsAdded(ctx, ref, availableDrillTargets, correlationId)];
        }
    });
}
exports.addDrillTargetsHandler = addDrillTargetsHandler;
//# sourceMappingURL=addDrillTargetsHandler.js.map